import React, { useState, useEffect } from "react";
import Header from "./Header";
import VideoPreview from "./VideoReviewPreview";

window.AUTH_TOKEN = window.localStorage.getItem("authorization") || "";

const testAuth = async () => {
  try {
    const response = await fetch(
      "https://one-in-three.appspot.com/pending-video",
      {
        method: "GET",
        headers: {
          "X-Auth-Token": window.AUTH_TOKEN
        }
      }
    );
    return response;
  } catch (err) {
    console.error("Error", err);
  }
};

const AuthPrompt = ({ children }) => {
  const [authed, setAuthed] = useState(false);
  const [denied, setDenied] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (window.AUTH_TOKEN === "") return;
    onSubmit();
  });

  const onSubmit = async () => {
    try {
      const response = await testAuth();
      if (response.status === 200) {
        setAuthed(true);
        setDenied(false);
        window.localStorage.setItem("authorization", window.AUTH_TOKEN);
      } else {
        setSubmitting(false);
        setAuthed(false);
        setDenied(true);
      }
    } catch (e) {
      console.error(e);
      setAuthed(false);
      setDenied(true);
    }
  };

  const inputStyle = denied ? { borderColor: "red" } : null;

  return authed ? (
    children
  ) : (
    <div className="Auth">
      {denied ? (
        <div style={{ color: "red" }}>
          Your password is incorrect. Please try again.{" "}
        </div>
      ) : (
        <div>Welcome, please enter your password:</div>
      )}
      <input
        type="password"
        onChange={e => (window.AUTH_TOKEN = e.target.value)}
        style={inputStyle}
      ></input>
      <button onClick={onSubmit}>Submit</button>
    </div>
  );
};

export default () => {
  return (
    <div className="Page">
      <Header>
        <li>Home</li>
        <li>About</li>
      </Header>
      <AuthPrompt>
        <VideoPreview />
      </AuthPrompt>
    </div>
  );
};
